import { render, staticRenderFns } from "./Novo-Fornecedor.vue?vue&type=template&id=e5dc6d3e&scoped=true&"
import script from "./Novo-Fornecedor.vue?vue&type=script&lang=js&"
export * from "./Novo-Fornecedor.vue?vue&type=script&lang=js&"
import style0 from "./Novo-Fornecedor.vue?vue&type=style&index=0&id=e5dc6d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dc6d3e",
  null
  
)

export default component.exports